import climateTalks from '../assets/images/gallery/climate_talks_1.jpeg'
import mentalHealth1 from '../assets/images/gallery/mental_health_1.jpeg'
import mentalHealth2 from '../assets/images/gallery/mental_health_2.jpeg'
import mentalHealth3 from '../assets/images/gallery/mental_health_3.jpeg'
import youthEducation1 from '../assets/images/gallery/youth_education_1.jpeg'
import youthEducation2 from '../assets/images/gallery/youth_education_2.jpeg'
import youthEducation3 from '../assets/images/gallery/youth_education_3.jpeg'
import youthEducation4 from '../assets/images/gallery/youth_education_4.jpeg'
import youthEmpowerment1 from '../assets/images/gallery/youth_empowerment_1.jpeg'
import youthEmpowerment2 from '../assets/images/gallery/youth_empowerment_2.jpeg'
import youthEmpowerment3 from '../assets/images/gallery/youth_empowerment_3.jpeg'
import youthEmpowerment4 from '../assets/images/gallery/youth_empowerment_4.jpeg'
import youthEmpowerment5 from '../assets/images/gallery/youth_empowerment_5.jpeg'


const gallery = {
  // Main program images
  programs: [
    {
      id: 'climate-talks',
      title: 'Climate Talks',
      image: climateTalks,
      description: 'Climate talks',
      category: 'climate',
      alt: 'Climate talks'
    },
    {
      id: 'mental-health-1',
      title: 'Mental Health Talks',
      image: mentalHealth1,
      description: 'Mental health talks',
      category: 'Mental health',
      alt: 'Mental health talks'
    },
    {
      id: 'mental-health-2',
      title: 'Mental Health Talks',
      image: mentalHealth2,
      description: 'Mental health talks',
      category: 'Mental health',
      alt: 'Mental health talks'
    },
    {
      id: 'mental-health-3',
      title: 'Mental Health Talks',
      image: mentalHealth3,
      description: 'Mental health talks',
      category: 'Mental health',
      alt: 'Mental health talks'
    },
    {
      id: 'youth-education-1',
      title: 'Youth Education',
      image: youthEducation1,
      description: 'Youth education',
      category: 'Education',
      alt: 'Youth education'
    },
    {
      id: 'youth-education-2',
      title: 'Youth Education',
      image: youthEducation2,
      description: 'Youth education',
      category: 'Education',
      alt: 'Youth education'
    },
        {
      id: 'youth-education-3',
      title: 'Youth Education',
      image: youthEducation3,
      description: 'Youth education',
      category: 'Education',
      alt: 'Youth education'
    },
    {
      id: 'youth-education-4',
      title: 'Youth Education',
      image: youthEducation4,
      description: 'Youth education',
      category: 'Education',
      alt: 'Youth education'
    },
    {
      id: 'youth-empowerment-1',
      title: 'Youth Empowerment',
      image: youthEmpowerment1,
      description: 'Youth empowerment',
      category: 'Empowerment',
      alt: 'Youth empowerment'
    },
        {
      id: 'youth-empowerment-2',
      title: 'Youth Empowerment',
      image: youthEmpowerment2,
      description: 'Youth empowerment',
      category: 'Empowerment',
      alt: 'Youth empowerment'
    },
        {
      id: 'youth-empowerment-3',
      title: 'Youth Empowerment',
      image: youthEmpowerment3,
      description: 'Youth empowerment',
      category: 'Empowerment',
      alt: 'Youth empowerment'
    },
        {
      id: 'youth-empowerment-4',
      title: 'Youth Empowerment',
      image: youthEmpowerment4,
      description: 'Youth empowerment',
      category: 'Empowerment',
      alt: 'Youth empowerment'
    },
      {
      id: 'youth-empowerment-5',
      title: 'Youth Empowerment',
      image: youthEmpowerment5,
      description: 'Youth empowerment',
      category: 'Empowerment',
      alt: 'Youth empowerment'
    },
  ],
};

// Helper function to get all images
export const getAllGalleryImages = () => {
  return [
    ...gallery.programs,
  ];
};

// Helper function to get images by category
export const getImagesByCategory = (category) => {
  const allImages = getAllGalleryImages();
  return allImages.filter(image => image.category === category);
};

// Helper function to get available categories
export const getGalleryCategories = () => {
  const allImages = getAllGalleryImages();
  const categories = [...new Set(allImages.map(image => image.category))];
  return categories.map(category => ({
    id: category,
    name: category.charAt(0).toUpperCase() + category.slice(1),
    count: allImages.filter(image => image.category === category).length
  }));
};

export default gallery;